var OpenEvent = window.OpenEvent = (function () {
    var self;

    const selectors = {
        eventFavstar: '[oe-favstar]',
        searchFavstar: '[search-favstar]',
        searchEvent: '[search-event]'
    };

    const DEFER_TIMEOUT = 500;
    var timeoutPool = {};
    function deferAction(key, action) {
        clearTimeout(timeoutPool[key]);
        timeoutPool[key] = setTimeout(function () {
            action();
            delete timeoutPool[key];
        }, DEFER_TIMEOUT);
    }

    function getEventBlockInstanceById(eventId) {
        return (self.EventInstance.id == eventId) ? self.EventInstance : null;
    }

    function bindUI() {
        //Fave UnFave
        app.body.on('click', selectors.eventFavstar + ',' + selectors.searchFavstar, function () {
            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = !that.closest(selectors.searchEvent).length ? self.EventInstance.id : that.closest(selectors.searchEvent).data('id');

            var mainEvent = document.querySelector('[data-mei]')
            var mainEventId = mainEvent ? Number(mainEvent.dataset.mei) : NaN;

            var allStars = (eventId === self.EventInstance.id) ? $.merge($(selectors.eventFavstar), $(selectors.searchEvent + '[data-id=' + eventId + ']').find(selectors.searchFavstar)) : $(selectors.searchEvent + '[data-id=' + eventId + ']').find(selectors.searchFavstar);
            var typeUrlPart = (self.EventInstance.isLive) ? '/Live' : '/Prematch';
            var actionUrlPart = (isRemovingFromFav) ? '/UnFaveEvent' : '/FaveEvent';
            that.addClass('m-loading');
            if (isRemovingFromFav) {
                allStars.removeClass('m-active');
                allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_10', 'Добавить в избранное'));
            }
            else {
                allStars.addClass('m-active');
                allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_11', 'Удалить из избранного'));
            }
            Ajax.postJson(typeUrlPart + actionUrlPart, {
                data: {
                    id: mainEventId || eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    that.removeClass('m-loading');
                },
            });

            return;
        });
    }

    function unBindUI() {
        app.body.off('click', selectors.eventFavstar + ',' + selectors.searchFavstar);
    }

    return {
        init: function () {
            self = this;

            var wrapperNode = $('#event-instance-wrapper');
            if (wrapperNode.length == 1) {
                this.EventInstance = new EventBlock(wrapperNode, EventBlock.EType.OpenEvent);
            }
            else {
                Ajax.redirect('/live');
            }

            BettingCart.Highlighting.activate.openEvent();
            bindUI();
        },
        dispose: function () {
            unBindUI();
            if (this.EventInstance) {
                this.EventInstance.dispose();
            }
        }
    }
}());
